export default {
  filterDomainLectures: {},
  filterDomainLecturesPosition: {},
  learningElement: {},
};



// WEBPACK FOOTER //
// ./src/app/domain-lecture/store/state.js